<template>
	<section>
		<uiModal name="status-subscrib" title="Status de Assinatura" size="xs" @close="close">
			<div class="content scroll-color">
				<section
					class="doc-content"
					v-for="(elementGeneral, indexGeneral) in list"
					:key="indexGeneral"
				>
					<div class="doc-name">{{ elementGeneral.docName }}</div>
					<div
						class="list-group-item"
						v-for="(element, index) in elementGeneral.status"
						:key="index"
					>
						<div class="infos-user" v-if="element.group">
							<div class="name">{{ element.name }}</div>
							<div class="groups">{{ element.group }}</div>
						</div>
						<ui-info-tag
							option-class="sm success"
							v-if="getStatusName(element.status) == 'Aprovado'"
						>
							{{ getStatusName(element.status) }}
						</ui-info-tag>
						<ui-info-tag
							option-class="sm danger"
							v-else-if="getStatusName(element.status) == 'Rejeitado'"
						>
							{{ getStatusName(element.status) }}
						</ui-info-tag>
						<ui-info-tag option-class="sm default" v-else>
							{{ getStatusName(element.status) }}
						</ui-info-tag>
					</div>
				</section>
			</div>
		</uiModal>
	</section>
</template>

<script>
	import { uiInput } from '@/components/ui/form'
	import { uiModal } from '@/components/ui/modal'
	import { uiButton } from '@/components/ui/buttons'
	import { uiInfoTag } from '@/components/ui'

	export default {
		components: {
			uiInput,
			uiModal,
			uiButton,
			uiInfoTag,
		},

		data() {
			return {
				list: [],
			}
		},

		mounted() {
			this.$root.$on('modal-open-status-subscrib', () => {
				this.openIframe('closed-modal')
				this.mountList()
			})
		},

		beforeDestroy() {
			this.$root.$off('modal-open-status-subscrib')
		},

		methods: {
			close() {
				const event = new CustomEvent('iframe--request-modal')
				window.parent.document.dispatchEvent(event)
			},

			openIframe(value, data = null) {
				let event = new CustomEvent(`iframe--contracts-${value}`, { detail: data })
				window.parent.document.dispatchEvent(event)
			},

			mountList() {
				this.list = JSON.parse(this.$route.params.data)
			},

			getStatusName(status) {
				switch (status) {
					case 0:
						return 'Não iniciado'
					case 1:
						return 'Aguardando assinatura'
					case 2:
						return 'Fila de processamento'
					case 3:
						return 'Processando'
					case 4:
						return 'Aprovado'
					case 5:
						return 'Rejeitado'
					default:
						return 'Desconhecido'
				}
			},
		},
	}
</script>

<style lang="stylus" scoped>
	@import 'styles.styl'
</style>
